
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class OptionsList extends Vue {

  @Prop({default: null})
  public resourceId: number;

  @Prop({default: null})
  public resourceType: string;

  public optionTypes: any[] = [];
  public options: any[] = [];
  public loading: boolean = false;

  public async mounted() {
    this.loading = true;
    await this.fetchOptionTypes();
    await this.fetchResourceOptions();
    this.loading = false;
  }

  public async fetchOptionTypes(): Promise<void> {
    this.optionTypes = await this.$store.dispatch("options/readType", {
      resourceType: this.resourceType,
    });
  }

  public async fetchResourceOptions(): Promise<void> {
    this.options = await this.$store.dispatch("options/readOptionsByResource", {
      resourceType: this.resourceType,
      resourceId: this.resourceId,
      optionTypeLabelList: this.optionTypes
        .map((type) => type.label),
    });
  }

  private async onChangeOption(optionTypeLabel, value): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("options/updateByResourceId", {
      resourceType: this.resourceType,
      resourceId: this.resourceId,
      optionTypeLabel,
      value,
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    });
    this.loading = false;
  }
}
